module.exports = __webpack_public_path__ + "static/ink-d688c283af55ee8a5e73b55eda4a5c5f.jpg";